var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky-menu"},[_c('Cabinet'),_c('AddEditPost'),_c('user-posts',{attrs:{"method":'myfavouritesSticky',"userId":+_vm.User.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }